import { render, staticRenderFns } from "./TimeframeSelector.vue?vue&type=template&id=990bd30c&"
import script from "./TimeframeSelector.vue?vue&type=script&lang=js&"
export * from "./TimeframeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports